import type { RouteObject } from 'react-router-dom'

import type { NavItem } from '@/app/registry'

import { DataPage } from './DataPage'

export const routes: RouteObject[] = [{ path: '/settings/data', element: <DataPage /> }]

export const nav: NavItem[] = [
  { path: '/settings/data', label: 'Данные', icon: 'download', mobile: null, order: 80, parent: '/settings' },
]
